
import React, { FC, useState } from 'react';
import setTheme from '@lib/theme';
import {
    Card,
    Column,
    Row,
    Spacer,
    Text
} from '@components/1-atoms';
import * as utils from '@lib/utils';
import _ from 'underscore';
import Filter from '@assets/icons/filter';



type Props = { navigation: any; date: Date}

const theme = setTheme('light');

const BalanceSheetHeader: FC<Props> = ({ navigation, date, ...props }) => {

    const d:string = utils.formatDate(date, "MMM d, yyyy'");
    
    const dateRange = `On ${d}`;

    return (
        <Card>
            <Row>
                <Column>
                    <Text large>Date</Text>
                    <Spacer h={1} />
                    <Text color={"#7E7E7E"} small>{dateRange}</Text>
                </Column>
                <Spacer w={1} />

                {/* <Filter /> */}
            </Row>
        </Card>
    );
};

export default BalanceSheetHeader;